// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2026-10-01
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./TitleBar.module.scss";

// Simple bar with title.
export default function TitleBar(props: Props): Component {
  return (
    <div
      data-test="title-bar"
      className={`${styles.body} ${props.isLeftAligned ? styles.leftAligned : ""} ${props.isShort ? styles.short : ""}`}
    >
      <span>{props.title}</span>
      <span>{props.children}</span>
    </div>
  );
}

interface Props {
  title: string;
  isLeftAligned?: boolean;
  isShort?: boolean;
  children?: Children;
}
